import Backdrop from "@mui/material/Backdrop";
import { styled } from "@mui/material/styles";

const Overlay = styled(Backdrop)(({
	theme,
}) => ({
	background: "rgba(0,0,0,0.25)",
	position: "absolute",
	zIndex: "unset",
}));

export default Overlay;